import { render, staticRenderFns } from "./FileDocumentSettings.vue?vue&type=template&id=0199c460&"
import script from "./FileDocumentSettings.vue?vue&type=script&lang=js&"
export * from "./FileDocumentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports